import { graphql } from "react-relay";

export const teamSettingsAdminNoMeetingDayFragments = {
  org: graphql`
    fragment TeamSettingsAdminNoMeetingDay_org on Org
    @argumentDefinitions(teamId: { type: "String!" }) {
      id
      experiments
      teamSettings(teamId: $teamId) {
        __typename
        ... on TeamSettings {
          manageTeamCalendar
          useNoMeetingDay
          noMeetingDayOfWeek
          noMeetingDayEmailOnScheduleOver
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
  team: graphql`
    fragment TeamSettingsAdminNoMeetingDay_team on Team {
      id
      teamId
      teamName
      teamCalendarId
    }
  `,
};

export const refetchQuery = graphql`
  query TeamSettingsAdminNoMeetingDayQuery($orgRelayId: ID!, $teamId: String!) {
    orgRefetch: node(id: $orgRelayId) {
      ... on Org {
        ...TeamSettingsAdminNoMeetingDay_org @arguments(teamId: $teamId)
      }
    }
  }
`;
